/*
 *
 * Tables
 *
 */

import styled, { css } from 'styled-components';

import { FlexBox } from '../Blocks';
import media from '../../style/mediainjector';

export const TableContainer = styled(FlexBox)`
  width: 100%;
  align-items: stretch;
  margin: 20px auto 30px;
  ${media.lt768`
    flex-direction: column;
  `}
`;

export const TableBlock = styled.div`
  width: 50%;
  padding:10px 10px 10px 10px;
    &:first-child {
      padding-left: 0;
    }
    &:last-child {
      padding-right: 0;
    }
  ${media.lt768`
    width: 100%;
    padding: 0;
    `}
`;

export const Table = styled.table`
  width: 100%;
  border-collapse: collapse;
  border-spacing: 0;
  background-color: ${(props) => props.bgcolor};
  ${media.lt480`
    font-size: 12px;
  `}
  ${({ fixed }) => fixed && css`
    width: 100%;
    table-layout: fixed;
  `}
  strong {
    font-weight: 700;
  }
`;

export const Tr = styled.tr`
  border-bottom: ${(props) => props.borderBottom};
  background-color: ${(props) => props.backgroundColor};
`;

const tdThProps = css`
  color: ${({ color, theme: { fontColor } }) => color ? color : fontColor};
  padding: ${({ padding }) => padding ? padding : '14px 5px'};
  font-weight: ${({ fontWeight }) => fontWeight};
  font-size: ${({ fontSize }) => fontSize};
  background-color: ${({ backgroundColor }) => backgroundColor};
  border: ${(props) => props.border};
  text-align: ${({ textAlign }) => textAlign};
`;

export const Td = styled.td`
  ${tdThProps}
  overflow: hidden;
  word-break: normal;
`;

export const NoteTd = styled(Td)`
  padding: 6px 5px;
  font-size: 14px;
`;

export const Th = styled.th`
  ${tdThProps}
  color: ${({ color, theme: { dark } }) => color ? color : dark};
`;
